import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class PublicationsService {

  constructor(
    private http: HttpClient,
  ) { }

  getPublications():Observable<any>{
    return this.http.get(Services.publications).pipe(
      tap(publications => console.info(`fetched publications`))
    );
  }

  getPostDetails(token:string):Observable<any>{
    return this.http.get(`${Services.post}/${token}`).pipe(
      tap(posts => console.info(`fetched post`))
    );
  }
}
